(function () {
  'use strict';
  function setup(scope) {
    var root = scope || document;

    /* Menu mobile */
    var btn = document.querySelector('[data-zv-menu]');
    var nav = document.getElementById('ZvNav');
    if (btn && nav && !btn.dataset.ready) {
      btn.dataset.ready = '1';
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', String(open));
        nav.classList.toggle('is-open', open);
      });
      nav.addEventListener('click', function (e) {
        if (e.target.closest('a')) { btn.setAttribute('aria-expanded', 'false'); nav.classList.remove('is-open'); }
      });
    }

    /* Tu te reconnais ? */
    root.querySelectorAll('[data-zv-fears]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var data = [];
      try { data = JSON.parse(box.querySelector('[data-zv-fears-data]').textContent); } catch (e) { return; }
      var buttons = box.querySelectorAll('[data-zv-fear]');
      var f = function (sel) { return box.querySelector(sel); };
      buttons.forEach(function (b) {
        b.addEventListener('click', function () {
          var d = data[+b.getAttribute('data-zv-fear')];
          if (!d) return;
          buttons.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          f('[data-zv-a-label]').textContent = d.label;
          f('[data-zv-a-title]').textContent = d.title;
          f('[data-zv-a-text]').textContent = d.text;
          f('[data-zv-a-proof]').textContent = d.proof;
          var cta = f('[data-zv-a-cta]');
          cta.textContent = d.cta;
          cta.setAttribute('href', d.href);
        });
      });
    });

    /* Choix de l'offre : relie les options aux vraies variantes Shopify */
    root.querySelectorAll('[data-zv-buy]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var variants = [];
      try { variants = JSON.parse(box.querySelector('[data-zv-variants]').textContent); } catch (e) { return; }
      var currency = box.getAttribute('data-currency') || 'EUR';
      var money = function (c) { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: currency }).format(c / 100); };
      var helps = {
        peau: 'Version ovale (ZG0102) : elle se colle directement sur la peau, avec une chaleur plus douce.',
        vet: 'Version cœur (ZG0106) : elle se colle sur ta culotte ou ton legging, jamais directement sur la peau.'
      };
      function update() {
        var fmt = box.querySelector('input[data-zv-format]:checked');
        var app = box.querySelector('input[data-zv-app]:checked');
        if (!fmt || !app) return;
        var v = variants.filter(function (x) { return x.format === fmt.value && x.application === app.value; })[0];
        if (!v) return;
        var duo = /20/.test(fmt.value);
        var idInput = box.querySelector('[data-zv-variant-id]');
        if (idInput) idInput.value = v.id;
        var label = (duo ? 'Le duo · 2 boîtes' : '1 boîte') + ' · ' + (/peau/i.test(app.value) ? 'Sur la peau' : 'Sur les vêtements') + ' — ' + money(v.price);
        document.querySelectorAll('[data-zv-summary]').forEach(function (el) { el.textContent = label; });
        var help = box.querySelector('[data-zv-help]');
        if (help) help.textContent = /peau/i.test(app.value) ? helps.peau : helps.vet;
        var buttons = document.querySelectorAll('[data-zv-submit]');
        buttons.forEach(function (b) {
          b.disabled = !v.available;
          b.textContent = v.available ? 'Ajouter au panier · ' + money(v.price) : 'Bientôt disponible';
        });
        var status = box.querySelector('[data-zv-status]');
        if (status) status.textContent = v.available ? 'Expédié depuis la France · Paiement sécurisé' : 'Les ventes ouvrent bientôt.';
      }
      box.addEventListener('change', update);
      update();
    });

    /* Bouton de la barre collée : envoie le formulaire principal */
    document.querySelectorAll('[data-zv-sticky-submit]').forEach(function (b) {
      if (b.dataset.ready) return;
      b.dataset.ready = '1';
      b.addEventListener('click', function () {
        var form = document.querySelector('[data-zv-buy] form');
        if (form && !b.disabled) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
      });
    });

    /* Galerie produit */
    root.querySelectorAll('[data-zv-gallery]').forEach(function (g) {
      if (g.dataset.ready) return;
      g.dataset.ready = '1';
      var slides = g.querySelectorAll('[data-zv-slide]');
      var thumbs = g.querySelectorAll('[data-zv-thumb]');
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = t.getAttribute('data-zv-thumb');
          slides.forEach(function (s) { s.hidden = s.getAttribute('data-zv-slide') !== i; });
          thumbs.forEach(function (x) { x.setAttribute('aria-pressed', String(x === t)); });
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setup(); });
  else setup();
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
